<template>
    <v-card>                
        <v-toolbar flat color="primary" class="white--text">
            <v-toolbar-title>Units</v-toolbar-title>
            <v-spacer></v-spacer>                    
        </v-toolbar>
        <v-layout wrap>
            <v-flex xs12 sm3 offset-sm1>
                <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm2 offset-sm1>
                <v-btn color="primary" block @click="openEdit(null)">
                    Add
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :rows-per-page-items="rowsPerPageItems" 
                    :pagination.sync="pagination"
                    :search="search"
                    :loading="loading"
                    :items="dataFiltered"
                    class="compact-units-table">
                    <template v-slot:items="{ item }">
                        
                        <td>{{ item.Name }}</td>
                        <td>{{ item.ProductCategories.map(pc => `${pc.Name}${pc.IsDefault == true ? '*':''}`).join(', ') }}</td>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-chip v-on="on" text-color="white" :color="totalVarieties(item) > 0 ? 'primary' : 'grey'">{{ totalVarieties(item) }}</v-chip>
                                </template>                                
                                <span v-for="(variety, i) in getVarieties(item)" :key="i">{{variety.Description + ', '}}</span>                                
                            </v-tooltip>
                        </td>
                        <td>{{ item.PackSize }}</td>
                        <td>{{ item.TareKg }}</td>
                        <td>{{ item.MinimumTargetKg }}</td>
                        <td>{{ item.MaximumTargetKg }}</td>
                        <td>{{ item.AveKgsPerUnit }}</td>
                        <td>{{ item.RecordingMode }}</td>
                        <td>{{ item.NumInTray }}</td>
                        <td>{{ item.TrayWeight }}</td>
                        <td>{{ item.IsActive ? 'Yes' : 'No' }}</td>
                        <td>
                            <v-btn 
                                color="primary"
                                block 
                                @click="openEdit(item)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {            
            loading: false,
            search: '',
            activeOnly: true,
            rowsPerPageItems: [10, 25, 50, 100],
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            headers: [
                {
                    text: "Material Description",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Products",
                    value: "ProductCategories",
                    sortable: true
                },
                {
                    text: "Varieties",
                    value: "Varieties",
                    sortable: false
                },
                {
                    text: "Pack Size (Kg)",
                    value: "PackSize",
                    sortable: true
                },
                {
                    text: "Tare Weight (Kg)",
                    value: "TareKg",
                    sortable: true
                },
                {
                    text: "Min Target (Kg)",
                    value: "MinimumTargetKg",
                    sortable: true
                },
                {
                    text: "Max Target (Kg)",
                    value: "MaximumTargetKg",
                    sortable: true
                },
                {
                    text: "Avg Kgs per Unit",
                    value: "AveKgsPerUnit",
                    sortable: true
                },
                {
                    text: "Recording Mode",
                    value: "RecordingMode",
                    sortable: true
                },
                {
                    text: "# in Tray",
                    value: "NumInTray",
                    sortable: true
                },
                {
                    text: "Tray Weight (Kg)",
                    value: "TrayWeightKg",
                    sortable: true
                },
                {
                    text: "Active",
                    value: "Active",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        dataFiltered() {
            return this.data.filter(d => d.IsActive || !this.activeOnly);
        }
    },
    methods: {
        openEdit(item) {
            this.$emit("edit", item);
        },
        totalVarieties(item) {
            if (item.ProductCategories.length === 0) {
                return 0;
            }            

            return item.ProductCategories.reduce((a, b) => a += [...new Set(b.Varieties.map(v=> v.ProductVarietyID))].length, 0);
        },
        getVarieties(item) {
            let varities = [];

            item.ProductCategories.forEach(pc => {
                varities.push(...pc.Varieties);                
            });

            return varities.sort((a, b) => { if (a.Description < b.Description) { return -1; } else { return 1; } });
        }
    }
}
</script>
<style scoped>
.compact-units-table >>> table.v-table thead th.column{
    padding-left: 6px;
    padding-right: 6px;
}
.compact-units-table >>> table.v-table tbody td{
    padding-left: 6px;
    padding-right: 6px;
}
</style>